import React from "react";
import styles from "./ProductHeader.module.scss";

function ProductHeader({ product }) {
  const { owner } = product;
  return (
    <div className={styles.productDetail}>
      <div className={styles.sellerText}>
        <img src={owner.picture} />
        <div className={styles.sellerHeading}>
          <h3>{product.name}</h3>
          <label>{owner.name}</label>
        </div>
      </div>
    </div>
  );
}

export default ProductHeader;
